// API Configuration
// In production, default to Render backend if REACT_APP_API_URL is not set
// In development, use empty string to leverage proxy in package.json
const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const isDev = process.env.NODE_ENV === 'development';
const DEFAULT_BACKEND_URL = 'https://twodmvp.onrender.com';

// If no API URL is set:
// - In dev: use empty string (proxy will handle it)
// - In production: use default backend URL
export const API_URL = API_BASE_URL || (isDev ? '' : DEFAULT_BACKEND_URL);
export default API_URL;

